import { useDashboardPage } from 'pages/RedesignDashboard/hooks/dashboardPage.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { FACTOR_ENUMS } from 'pages/RedesignDashboard/constants';
import { factorMapping } from 'customHelpersPath/factorMapping.helper';

export const usePotentialScoreFactorsModule = props => {
  const { eventHandler, history, userInfo, location } = props;

  const {
    PAYMENT_HISTORY,
    ACCOUNT_MIX,
    CREDIT_AGE,
    CREDIT_INQUIRIES,
    CREDIT_USAGE,
  } = FACTOR_ENUMS;

  const { goToFactorPage } = useDashboardPage({
    userInfo: userInfo,
    history,
    location,
    isPotentialScoreFactorModule: true,
  });

  const handleClickInFactor = (
    selectedPotentialFactor,
    seenOfferModulePosition,
    eventClickType,
  ) => {
    eventHandler(CLICK, {
      'Click Type': eventClickType || 'See details',
      'Module Position': seenOfferModulePosition,
      'Module Name':
        'Potential - ' + factorMapping?.get(selectedPotentialFactor),
    });
    switch (selectedPotentialFactor) {
      case PAYMENT_HISTORY:
        goToFactorPage(PAYMENT_HISTORY);
        break;
      case CREDIT_USAGE:
        goToFactorPage(CREDIT_USAGE);
        break;
      case CREDIT_AGE:
        goToFactorPage(CREDIT_AGE);
        break;
      case ACCOUNT_MIX:
        goToFactorPage(ACCOUNT_MIX);
        break;
      case CREDIT_INQUIRIES:
        goToFactorPage(CREDIT_INQUIRIES);
        break;
      default:
        history.push('dashboard');
        break;
    }
  };

  const handleClickBereauReport = () => {
    eventHandler(CLICK, {
      'Click Type': '3-Bureau Report',
      'Module Position': 1,
      'Module Name': 'Potential - Payment History',
    });
    history.push('/creditReports/tabs');
  };

  const handleClickOpeningNewCreditCard = () => {
    eventHandler(CLICK, {
      'Click Type': 'Get A New Card',
      'Module Position': 2,
      'Module Name': 'Potential - Credit Usage',
    });
    history.push('/offers?vertical=CREDIT_CARD');
  };

  const handleClickGettingNewCard = () => {
    eventHandler(CLICK, {
      'Click Type': 'Get A New Card',
      'Module Position': 3,
      'Module Name': 'Potential - Credit Age',
    });
    history.push('/offers?vertical=CREDIT_CARD');
  };

  const handleClickOpenAccountToday = () => {
    eventHandler(CLICK, {
      'Click Type': 'Get A New Card',
      'Module Position': 4,
      'Module Name': 'Potential - Account Mix',
    });
    history.push('/offers?vertical=CREDIT_CARD');
  };

  const handleClickExploreAllPremiumBenefits = (
    seenOfferModulePosition,
    selectedPotentialFactor,
  ) => {
    eventHandler(CLICK, {
      'Click Type': 'Explore all premium benefits',
      'Module Position': seenOfferModulePosition,
      'Module Name':
        'Potential - ' + factorMapping?.get(selectedPotentialFactor),
    });
    history.push('/premium');
  };

  return {
    handleClickInFactor,
    handleClickBereauReport,
    handleClickOpeningNewCreditCard,
    handleClickGettingNewCard,
    handleClickOpenAccountToday,
    handleClickExploreAllPremiumBenefits,
  };
};
